export default {
  zh: {
    step: '步骤',
    ios: [{
      title: '登录连接',
      explain: '登录 Plex加速器客户端，一键快速连接，智能为您匹配最佳线路'
    }, {
      title: '线路选择',
      explain: '进入线路列表，您可以从推荐栏或所有地点标签栏中选择您需要的线路进行连接'
    }, {
      title: '开启保护',
      explain: '连接 Plex加速器开启安全保护，您可以安全隐匿地浏览网络、观看流媒体和下载'
    }],
    android: [{
      title: '登录连接',
      explain: '登录 Plex加速器客户端，一键快速连接，智能为您匹配最佳线路'
    }, {
      title: '线路选择',
      explain: '进入线路列表，您可以从推荐栏或所有地点标签栏中选择您需要的线路进行连接'
    }, {
      title: '开启保护',
      explain: '连接 Plex加速器开启安全保护，您可以安全隐匿地浏览网络、观看流媒体和下载'
    }],
    mac: [{
      title: '登录连接',
      explain: '登录 Plex加速器客户端，一键快速连接，智能为您匹配最佳线路'
    }, {
      title: '线路选择',
      explain: '进入线路列表，您可以从推荐栏或所有地点标签栏中选择您需要的线路进行连接'
    }, {
      title: '开启保护',
      explain: '连接 Plex加速器开启安全保护，您可以安全隐匿地浏览网络、观看流媒体和下载'
    }],
    ubuntu: [{
      title: '登录连接',
      explain: '登录 Plex加速器客户端，一键快速连接，智能为您匹配最佳线路'
    }, {
      title: '线路选择',
      explain: '进入线路列表，您可以从推荐栏或所有地点标签栏中选择您需要的线路进行连接'
    }, {
      title: '开启保护',
      explain: '连接 Plex加速器开启安全保护，您可以安全隐匿地浏览网络、观看流媒体和下载'
    }],
    androidTV: [{
      title: '登录连接',
      explain: '登录 Plex加速器客户端，一键快速连接，智能为您匹配最佳线路'
    }, {
      title: '线路选择',
      explain: '进入线路列表，您可以从推荐栏或所有地点标签栏中选择您需要的线路进行连接'
    }, {
      title: '开启保护',
      explain: '连接 Plex加速器开启安全保护，您可以安全隐匿地浏览网络、观看流媒体和下载'
    }],
    pc: [{
      signUp: '注册',
      title: '登录连接',
      explain: '登录 Plex加速器客户端，一键快速连接，智能为您匹配最佳线路'
    }, {
      title: '线路选择',
      explain: '进入线路列表，您可以从推荐栏或所有地点标签栏中选择您需要的线路进行连接'
    }, {
      title: '开启保护',
      explain: '连接 Plex加速器开启安全保护，您可以安全隐匿地浏览网络、观看流媒体和下载'
    }]
  },
  en: {
    step: 'Step',
    ios: [{
      title: 'Sign In & Connect',
      explain: 'Sign in and one-tap connect to PlexVPN. Smart matching of the best server for you'
    }, {
      title: 'Choose Server',
      explain: 'Click the servers list, choose a server you need to connect from the Recommend or other locations tabs'
    }, {
      title: 'Security Protection',
      explain: 'Connect to PlexVPN for security protection, you can browse the internet, watch streams and download in security and privacy'
    }],
    android: [{
      title: 'Sign In & Connect',
      explain: 'Sign in and one-tap connect to PlexVPN. Smart matching of the best server for you'
    }, {
      title: 'Choose Server',
      explain: 'Click the servers list, choose a server you need to connect from the Recommend or other locations tabs'
    }, {
      title: 'Security Protection',
      explain: 'Connect to PlexVPN for security protection, you can browse the internet, watch streams and download in security and privacy'
    }],
    mac: [{
      title: 'Sign In & Connect',
      explain: 'Sign in and one-tap connect to PlexVPN. Smart matching of the best server for you'
    }, {
      title: 'Choose Server',
      explain: 'Click the servers list, choose a server you need to connect from the Recommend or other locations tabs'
    }, {
      title: 'Security Protection',
      explain: 'Connect to PlexVPN for security protection, you can browse the internet, watch streams and download in security and privacy'
    }],
    ubuntu: [{
      title: 'Sign In & Connect',
      explain: 'Sign in and one-tap connect to PlexVPN. Smart matching of the best server for you'
    }, {
      title: 'Choose Server',
      explain: 'Click the servers list, choose a server you need to connect from the Recommend or other locations tabs'
    }, {
      title: 'Security Protection',
      explain: 'Connect to PlexVPN for security protection, you can browse the internet, watch streams and download in security and privacy'
    }],
    androidTV: [{
      title: 'Sign In & Connect',
      explain: 'Sign in and one-tap connect to PlexVPN. Smart matching of the best server for you'
    }, {
      title: 'Choose Server',
      explain: 'Click the servers list, choose a server you need to connect from the Recommend or other locations tabs'
    }, {
      title: 'Security Protection',
      explain: 'Connect to PlexVPN for security protection, you can browse the internet, watch streams and download in security and privacy'
    }],
    pc: [{
      signUp: 'Register',
      title: ' Sign In & Connect',
      explain: 'Sign in and one-tap connect to PlexVPN. Smart matching of the best server for you'
    }, {
      title: 'Choose Server',
      explain: 'Click the servers list, choose a server you need to connect from the Recommend or other locations tabs'
    }, {
      title: 'Security Protection',
      explain: 'Connect to PlexVPN for security protection, you can browse the internet, watch streams and download in security and privacy'
    }]
  }
}



// WEBPACK FOOTER //
// ./src/components/download/usePlexStep/lang.js